import './index.external.css';

var styles = {"button":"button-15h2h","buttonPrimary":"buttonPrimary-15h2h","buttonSecondary":"buttonSecondary-15h2h","buttonTertiary":"buttonTertiary-15h2h","buttonBlock":"buttonBlock-15h2h","buttonMobileBlock":"buttonMobileBlock-15h2h","iconButtonContent":"iconButtonContent-15h2h","iconButtonIcon":"iconButtonIcon-15h2h","buttonTransparent":"buttonTransparent-15h2h","iconButtonChildren":"iconButtonChildren-15h2h"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
